export const SET_CONTENT = 'SET_CONTENT';
export const CLEAR_CONTENT = 'CLEAR_CONTENT';

export const clearContent = {
  type: CLEAR_CONTENT,
}

export const setContent = (data) => {
  return {
    type: SET_CONTENT,
    payload: data,
  }
}